import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import "./DownloadApp.css";
import Navbar from "../navbar/Navbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import DownloadApk from "../../images/downloadApk.jpg";
import AddToHomeScreenOption from "../../images/addToHomeScreenOption.jpg";
import AddToHomeScreen from "../../images/addToHomeScreen.jpg";
import OpenFromHomeScreen from "../../images/openFromHomeScreen.jpg";
import ViewNotesApk from "./viewnotes.apk";
import Footer from "../footer/footer";
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
}));

export default function CenteredGrid() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Navbar />
      <Link id="back" to="/">
        <Button
          style={{ margin: "10px", marginTop: "80px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>

      <Grid container className="downloadapp-apk-container">
        <Grid item xs={12} md={6} id="da-apk-text-con">
          <h3>Download Apk</h3>
          <a href={ViewNotesApk} download>
            <button type="button">Download</button>
          </a>
        </Grid>

        <Grid item xs={12} md={6} className="da-img-con">
          <img src={DownloadApk} alt="download apk" />
        </Grid>
      </Grid>
      <Divider />

      <Grid container className="da-pwa-steps-con">
        <Grid item xs={12} style={{ textAlign: "center", fontSize: "26px" }}>
          <h2>Install PWA for better performance</h2>
          <Divider />
        </Grid>

        <Grid item xs={12} md={6} className="da-pwa-steps-text">
          <h2>Step 1</h2>
          <p>
            Click on <strong>Add to Home screen</strong>
          </p>
        </Grid>
        <Grid item xs={12} md={6} className="da-pwa-img-con">
          <img src={AddToHomeScreenOption} alt="download apk" />
        </Grid>
      </Grid>

      <Divider />

      <Grid container className="da-pwa-steps-con">
        <Grid id="mob" item xs={12} md={6} className="da-pwa-steps-text">
          <h2>Step 2</h2>
          <p>
            Click on <strong>Add</strong>
          </p>
        </Grid>

        <Grid item xs={12} md={6} className="da-pwa-img-con">
          <img src={AddToHomeScreen} alt="download apk" />
        </Grid>
        <Grid id="desk" item xs={12} md={6} className="da-pwa-steps-text">
          <h2>Step 2</h2>
          <p>
            Click on <strong>Add</strong>
          </p>
        </Grid>
      </Grid>

      <Divider />

      <Grid container className="da-pwa-steps-con">
        <Grid item xs={12} md={6} className="da-pwa-steps-text">
          <h2>Step 3</h2>
          <p>
            Go to <strong>Home screen</strong>
            <p>
              Click on <strong>ViewNotes</strong> icon
            </p>
          </p>
        </Grid>
        <Grid item xs={12} md={6} className="da-pwa-img-con">
          <img src={OpenFromHomeScreen} alt="download apk" />
        </Grid>
      </Grid>
      <Divider />
      <Footer />
    </div>
  );
}
